import {
  Edit,
  SimpleForm,
  SelectInput,
  TextInput,
  ReferenceInput,
  required,
} from 'react-admin';

export const JivoChatEdit = () => (
  <Edit redirect="show">
    <SimpleForm>
      <TextInput source="name" fullWidth label="Имя" required />
      <TextInput source="provider_id" fullWidth label="Provider ID" required />
      <TextInput source="token" fullWidth label="Токен" required />
      <TextInput
        label="Стартовое сообщение"
        variant="outlined"
        multiline
        minRows={4}
        maxRows={6}
        source="start_message"
        fullWidth
        placeholder="Введите стартовое сообщение"
        validate={[required('Обязательно для заполнения')]}
      />
      <ReferenceInput source="model_id" reference="models" label="Модель">
        <SelectInput source="id" label="Модель" optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
